/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({ 
    state: {
        filesAdd: [],
        token: 0,
        anotherVar: '',
        locationMain: true,
        locationAdd: false,
        locationsArrow: null,
        locationsEdite: null,
        statusesArrow: null,
        AddHeader: 'ДОБАВИТЬ ОБЪЕКТ',
        objectVisibleMain: true,
        objectVisibleAdd: false,
        objectsArrow: null,
        objectEdite: null,
        objectAdd: false,
        staffVisibleMain: true,
        staffVisibleAdd: false,
        staffArrow: null,
        staffEdite: null,
        staffAdd: false,
        profile: {
            corporate: {
                balance: {not_shared: 0, workers: 0, hold: 0},
                id: 6,
                manager: {
                    email: "",
                    id: null,
                    name: "",
                    phone: "",
                    picture: "",
                    position: "",
                    schedule: ""
                },
                name: "т",
                worker: {
                    auto_charge_level: 0,
                    auto_charge_sum: 0,
                    name: ""
                }
            },
            corporates: [
                {
                    address: "",
                    balance: {not_shared: 0, workers: 0, hold: 0},
                    bank_account: "",
                    bank_master_account: "",
                    bank_name: "",
                    bik: "",
                    full_name: "",
                    id: null,
                    inn: "",
                    is_active: true,
                    kpp: "",
                    manager_id: null,
                    money: 0,
                    name: "",
                    workers: []
                }
            ],
            id: null,
            name: "",
            phone: ""
        }
    },
    mutations: {
        filesAdd(state, value) {
            state.filesAdd = value;
        },
        setToken(state, value) {
            state.token = value;
        },
        sendToken() {
            return state.token
        },
        setAnotherVar(state, value) {
            state.anotherVar = value
        },
        logout(state){
            state.token = ''
            state.anotherVar = ''
        },
        locationMain(state){
            state.locationMain = true
            state.locationAdd = false
        },
        locationAdd(state){
            state.locationMain = false
            state.locationAdd = true
        },
        locationsArrow(state, data) {
            state.locationsArrow = data
        },
        locationsEdite(state, data) {
            state.locationsEdite = data
        },
        statusesArrow(state, data) {
            state.statusesArrow = data
        },
        AddHeader(state, data){
            state.AddHeader = data
        },
        objectVisibleMain(state){
            state.objectVisibleMain = true
            state.objectVisibleAdd = false
        },
        objectVisibleAdd(state){
            state.objectVisibleMain = false
            state.objectVisibleAdd = true
        },
        objectsArrow(state, data){
            state.objectsArrow = data
        },
        objectEdite(state, data){
            state.objectEdite = data
        },
        objectAdd(state, data){
            state.objectAdd = data
        },
        staffVisibleMain(state){
            state.staffVisibleMain = true
            state.staffVisibleAdd = false
        },
        staffVisibleAdd(state){
            state.staffVisibleMain = false
            state.staffVisibleAdd = true
        },
        staffArrow(state, data){
            state.staffArrow = data
        },
        staffEdite(state, data){
            state.staffEdite = data
        },
        staffAdd(state, data){
            state.staffAdd = data
        },
        profileAdd(state, data){
            state.profile = data
        }
    },
    getters: {
        filesAdd: state => state.filesAdd,
        token: state => state.token,
        anotherVar: state => state.anotherVar,
        locationMain: state => state.locationMain,
        locationAdd: state => state.locationAdd,
        locationsArrow: state => state.locationsArrow,
        locationsEdite: state => state.locationAdd,
        statusesArrow: state => state.statusesArrow,
        objectVisibleMain: state => state.objectVisibleMain,
        AddHeader: state => state.AddHeader,
        objectVisibleAdd: state => state.objectVisibleAdd,
        objectsArrow: state => state.objectsArrow,
        objectEdite: state => state.objectEdite,
        objectAdd: state => state.objectAdd,
        staffVisibleMain: state => state.staffVisibleMain,
        staffVisibleAdd: state => state.staffVisibleAdd,
        staffArrow: state => state.staffArrow,
        staffEdite: state => state.staffEdite,
        staffAdd: state => state.staffAdd,
        profileAdd: state => state.profile
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js